import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { createPortal } from "react-dom";

const FullScreenModal = forwardRef(({ children }, ref) => {
    const fullScreenDialogRef = useRef();

    useImperativeHandle(ref, () => ({
        open: () => {
            if (fullScreenDialogRef.current) fullScreenDialogRef.current.showModal();
        },
        close: () => {
            if (fullScreenDialogRef.current) fullScreenDialogRef.current.close();
        },
    }));

    const handleClickOutside = (event) => {
        if (event.target === fullScreenDialogRef.current) {
            fullScreenDialogRef.current.close();
        }
    };

    return createPortal(
        <dialog className="fullscreen-modal" ref={fullScreenDialogRef} onClick={handleClickOutside}>
            <div className="fullscreen-modal-content">{children}</div>
        </dialog>,
        document.getElementById("fullscreen-modal")
    );
});

export default FullScreenModal;